module.exports = __webpack_public_path__ + "img/alert_ref.57e3345b.svg";